import { ELanguage } from "utils/i18n";

export const LANGUAGES = [
  {
    key: ELanguage.VI,
    name: "Việt Nam",
    icon: require("assets/icons/vietnam.png"),
  },
  {
    key: ELanguage.EN,
    name: "English",
    icon: require("assets/icons/english.png"),
  },
  {
    key: ELanguage.JP,
    name: "日本",
    icon: require("assets/icons/japan.png"),
  },
  {
    key: ELanguage.ZH,
    name: "中国",
    icon: require("assets/icons/china.png"),
  },
  {
    key: ELanguage.KO,
    name: "한국인",
    icon: require("assets/icons/korean.png"),
  },
];
